import React from "react";
import Img from "../../molecules/Img";
import idsc from "../../../assets/pics/footer/idsc.png";
import citymemory from "../../../assets/pics/footer/citymemory.png";
import streetstory from "../../../assets/pics/footer/streetstory.png";
import institute from "../../../assets/pics/footer/institute.png";
import cultureministry from "../../../assets/pics/footer/cultureministry.png";
import facebook from "../../../assets/pics/footer/facebook.png";
import instgram from "../../../assets/pics/footer/instgram.png";
import whatsapp from "../../../assets/pics/footer/whatsapp.png";
import youTube from "../../../assets/pics/footer/logos_youtube-icon.png";
import idsclogo from "../../../assets/pics/footer/idsclogo.png";
import institutelogo from "../../../assets/pics/footer/institutelogo.png";
import code from "../../../assets/pics/footer/code.png";
import location from "../../../assets/pics/footer/location.png";
import envelope from "../../../assets/pics/footer/envelope.png";
import phone from "../../../assets/pics/footer/phone.png";
import fax from "../../../assets/pics/footer/fax.png";
import apple from "../../../assets/pics/footer/apple.png";
import google_play from "../../../assets/pics/footer/google-play.png";
import qrCodeApple from "../../../assets/pics/footer/qrCodeAppstore.jpg";
import qrCodeGoogle from "../../../assets/pics/footer/qrCodegoogleplay.jpg";
import { useTranslation } from "react-i18next";
export default function Footer() {
  const { t } = useTranslation();
  const links = {
    idsc: "http://idsc.gov.eg",
    national_org_urban_harmony: "http://urbanharmony.org/ar_home.asp",
    cultureministry: "http://www.moc.gov.eg/en/",
    street_story: "https://streetstory.gov.eg/",
    city_memory: "http://www.memoryofthecity.gov.eg/",

    facebook: "https://www.facebook.com/profile.php?id=100063829523142",
    youtube: "https://www.youtube.com/@urbanharmony2356",
    rights:
      "http://urbanharmony.org/ar_home.asp#:~:text=%D8%AC%D9%85%D9%8A%D8%B9-,%D8%AD%D9%82%D9%88%D9%82,-%D8%A7%D9%84%D8%B7%D8%A8%D8%B9%20%D9%88%D8%A7%D9%84%D9%86%D8%B4%D8%B1%20%D9%85%D8%AD%D9%81%D9%88%D8%B8%D8%A9",

    castle_location: { lat: 30.029846410982135, long: 31.265212927089262 },
    urban_harmony_location: { lat: 30.018459, long: 31.750441 },
  };

  const handleOnClick = (link) => {
    console.log("clicked", link);
    window.open(link, "_blank", "noopener,noreferrer");
  };

  const getGoogleMapsLink = (lat, long) => {
    let link = `https://www.google.com/maps?q=${lat},${long}`;
    window.open(link, "_blank", "noopener,noreferrer");
  };

  return (
    <div className="flex h-[380px] w-full max-w-[100vw] flex-col items-center justify-between bg-[#F5F5F5]">
      <div className="bg-pik-400 w-full h-full pt-[30px] ">
        <div className="bg-pik-200 h-2/3 flex flex-row justify-center items-center">
          <div className="bg-[#F5F5F5] h-full w-11/12 lg:w-3/5 border border-amber rounded-[8px] flex flex-row justify-around items-center">
            <div
              className="bg-re-500 w-1/5 flex flex-row justify-around items-center cursor-pointer"
              onClick={() => handleOnClick(links.idsc)}
            >
              <Img src={idsc} alt={"idsc"} footer />
            </div>
            <div
              className="bg-rd-500 w-1/5 flex flex-row justify-around items-center cursor-pointer"
              onClick={() => handleOnClick(links.national_org_urban_harmony)}
            >
              <Img src={institute} alt={"national_org_urban_harmony"} footer />
            </div>
            <div
              className="bg-re-500 w-1/5 flex flex-row justify-around items-center cursor-pointer"
              onClick={() => handleOnClick(links.cultureministry)}
            >
              <Img src={cultureministry} alt={"cultureministry"} footer />
            </div>
            <div
              className="bg-rd-500 w-1/5 flex flex-row justify-around items-center cursor-pointer"
              onClick={() => handleOnClick(links.street_story)}
            >
              <Img src={streetstory} alt={"street_story"} footer />
            </div>
            <div
              className="bg-re-500 w-1/5 flex flex-row justify-around items-center cursor-pointer"
              onClick={() => handleOnClick(links.city_memory)}
            >
              <Img src={citymemory} alt={"citymemory"} footer />
            </div>
          </div>
        </div>

        <div className="flex h-1/3 w-full max-w-full flex-row items-center justify-center">
          <div className="flex h-full w-full min-w-0 max-w-full flex-row items-center justify-between gap-2 px-2 md:w-11/12 md:gap-4 md:px-0 lg:w-3/5">
            <div className="flex min-w-0 flex-row items-center justify-center gap-x-2 rounded-lg px-2 py-1 md:gap-x-3 md:px-4 md:py-2">
              <div className="font-tajawal-regular text-xs lg:text-base whitespace-nowrap">
                {t("footer.appName")}
              </div>
              <div className="flex flex-row justify-center items-center gap-x-2">
                <div className="flex flex-row justify-center items-center gap-x-2">
                  <Img src={qrCodeApple} alt={"qrCodeApple"} charIcon2 />
                  <Img src={apple} alt={"apple"} charIcon3 />
                </div>
                <div className="flex flex-row justify-center items-center gap-x-2">
                  <Img src={qrCodeGoogle} alt={"qrCodeGoogle"} charIcon2 />
                  <Img src={google_play} alt={"google_play"} charIcon3 />
                </div>
              </div>
            </div>
            <div className="flex shrink-0 flex-row items-center justify-center gap-x-2 rounded-lg px-1 py-1 md:gap-x-4 md:px-4 md:py-2">
              <div
                className="flex flex-row justify-center items-center cursor-pointer"
                onClick={() => handleOnClick(links.facebook)}
              >
                <Img src={facebook} alt={"facebook"} socialmedia />
              </div>
              <div
                className="flex flex-row justify-center items-center cursor-pointer"
                onClick={() => handleOnClick(links.youtube)}
              >
                <Img src={youTube} alt={"youTube"} socialmedia />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-[#D6A300] h-full md:h-28 w-full flex flex-col md:flex-row justify-between items-center py-2 px-2 ps-5">
        <div className="flex flex-col justify-center items-start bg-ed-500  w-full lg:w-1/3">
          <div
            className="flex flex-row justify-start items-center mb-1 w-full cursor-pointer gap-x-2"
            onClick={() =>
              getGoogleMapsLink(
                links.castle_location.lat,
                links.castle_location.long,
              )
            }
          >
            <div className="ms-0">
              <Img src={location} alt={"location"} charIcon />
            </div>
            <div className="font-tajawal-regular text-sm lg:text-base text-start bg-rd-400">
              {t("footer.addressCastle")}
            </div>
          </div>
          <div
            className="flex flex-row justify-start items-center w-full cursor-pointer gap-x-2"
            onClick={() =>
              getGoogleMapsLink(
                links.urban_harmony_location.lat,
                links.urban_harmony_location.long,
              )
            }
          >
            <div>
              <Img src={location} alt={"location"} charIcon />
            </div>
            <div className="font-tajawal-regular text-sm lg:text-base text-start bg-rd-400">
              {t("footer.addressAdminCapital")}
            </div>
          </div>
        </div>

        <div className="flex flex-col md:h-[53px] w-full justify-center items-start bg-ed-500 w-full lg:w-1/3">
          <div className="flex flex-row justify-start md:justify-center items-start mb-1 h-full w-full bg-ed-400 gap-x-2">
            <div>
              <Img src={phone} alt={"location"} charIcon />
            </div>
            <div className="flex flex-row justify-center items-center gap-x-2">
              <div className="font-tajawal-regular text-sm lg:text-base">
                (+202) 25145558
              </div>
            </div>
          </div>
        </div>

        <div className="flex flex-col justify-center items-start bg-ed-500 w-full lg:w-1/3">
          <div className="flex flex-row justify-start items-center mb-1 w-full gap-x-2">
            <div>
              <Img src={envelope} alt={"location"} charIcon />
            </div>
            <div className="font-tajawal-regular text-sm lg:text-base">
              Info.nouh@moc.gov.eg
            </div>
          </div>
          <div className="flex flex-row justify-start items-center w-full gap-x-2">
            <div>
              <Img src={envelope} alt={"location"} charIcon />
            </div>
            <div className="font-tajawal-regular text-sm lg:text-base">
              {t("footer.postal")}
            </div>
          </div>
        </div>
      </div>

      <div className="flex flex-row justify-center items-center w-full bg-[#B78C04] h-12 text-white font-tajawal-regular">
        <div className="flex flex-row justify-center items-center w-full">
          {/* <div className='mx-[5px]'>
           مركز المعلومات و دعم اتخاذ القرار
           </div> 
           <div>
             2023 - 1985 
            ©
           </div>  */}
          <div
            // className='cursor-pointer text-sm md:text-base'
            className="text-sm md:text-base"
            // onClick={() => handleOnClick(links.rights)}
          >
            {t("footer.rights")}
          </div>
        </div>
      </div>
    </div>
  );
}

// import React from 'react';

// export default function Footer() {
//   return (
//     <div className="h-[400px] bg-red-500 flex flex-col justify-between items-center">
//       {/* Top Section */}
//       <div className="flex flex-col items-center gap-8">
//         {/* Row of 4 Pictures */}
//         <div className="flex gap-4">
//           <img src="/path/to/pic1.png" alt="Pic 1" className="h-16 w-16" />
//           <img src="/path/to/pic2.png" alt="Pic 2" className="h-16 w-16" />
//           <img src="/path/to/pic3.png" alt="Pic 3" className="h-16 w-16" />
//           <img src="/path/to/pic4.png" alt="Pic 4" className="h-16 w-16" />
//         </div>

//         {/* Social Media and Additional Pictures */}
//         <div className="flex justify-between w-full px-8">
//           <div className="flex gap-4">
//             <img src="/path/to/pic5.png" alt="Pic 5" className="h-16 w-16" />
//             <img src="/path/to/pic6.png" alt="Pic 6" className="h-16 w-16" />
//           </div>
//           <div className="flex gap-4">
//             <img src="/path/to/facebook.png" alt="Facebook" className="h-8 w-8" />
//             <img src="/path/to/whatsapp.png" alt="WhatsApp" className="h-8 w-8" />
//             <img src="/path/to/instagram.png" alt="Instagram" className="h-8 w-8" />
//           </div>
//         </div>
//       </div>

//       {/* Bottom Section */}
//       <div className="flex flex-row justify-center items-center w-full bg-amber-600 h-1/6 text-white font-tajawal-regular text-sm">
//         <div className="flex flex-col items-center">
//           <div>مركز المعلومات و دعم اتخاذ القرار</div>
//           <div className="flex gap-2">
//             <span>2023 - 1985</span>
//             <span>©</span>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }
